<template>
  <CommonFieldSelect
      v-bind="$attrs"
      :items="items"
      :clearable="true"
      dense
      :label="label"
      @input="$emit('input', $event)"
      class="mb-n3"
      itemText="text"
      itemValue="value"
  ></CommonFieldSelect>
</template>

<script>

import CommonFieldSelect from "@/components/Common/CommonFieldSelect";

export default {
  name: 'ComponentMsdSelect',
  inheritAttrs: false,

  props: {
    label: {default: 'MSL'},
  },

  components: {
    CommonFieldSelect,
  },

  computed: {},

  methods: {},

  async mounted() {
  },

  data() {
    return {
      items: [
        {value: '1', text: '1 - unbegrenzt'},
        {value: '2', text: '2 - 1 Jahr'},
        {value: '2a', text: '2a - 4 Wochen'},
        {value: '3', text: '3 - 168 Stunden'},
        {value: '4', text: '4 - 72 Stunden'},
        {value: '5', text: '5 - 48 Stunden'},
        {value: '5a', text: '5a - 24 Stunden'},
        {value: '6', text: '6 - time on label (TOL)'},
      ]

    }
  }
}
</script>

<style scoped lang="scss">
</style>
